export default "__VITE_ASSET__DnJdt1X8__"